export default {"src":"/_next/static/media/icon_15.0f0b51c5.svg","height":34,"width":34};